var map = {
	"./images/aquarius.svg": "0e15",
	"./images/aries.svg": "d632",
	"./images/cancer.svg": "e9a1",
	"./images/capricorn.svg": "433e",
	"./images/east-calendar/bull.svg": "0ade",
	"./images/east-calendar/cock.svg": "d93f",
	"./images/east-calendar/dog.svg": "92f3",
	"./images/east-calendar/dragon.svg": "db22",
	"./images/east-calendar/goat.svg": "dd2a",
	"./images/east-calendar/horse.svg": "0b2d",
	"./images/east-calendar/monkey.svg": "264e",
	"./images/east-calendar/pig.svg": "bfd8",
	"./images/east-calendar/rabbit.svg": "0b4a",
	"./images/east-calendar/rat.svg": "3d5b",
	"./images/east-calendar/snake.svg": "e4dd",
	"./images/east-calendar/tiger.svg": "c39e",
	"./images/gemini.svg": "2336",
	"./images/leo.svg": "3697",
	"./images/libra.svg": "502a",
	"./images/pisces.svg": "ea0e",
	"./images/sagittarius.svg": "0910",
	"./images/scorpion.svg": "3949",
	"./images/taurus.svg": "cdf7",
	"./images/virgo.svg": "f21d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5582";